import { InjectionToken } from '@angular/core';
import type { ToastComponent } from '../../../Components/Dialogs/Toast/ToastComponent';
import type { IResolveRejectRef } from './IResolveRejectRef';

/**
 * @public
 */
export const TOAST_REF = new InjectionToken<IToastRef>('Toast ref');

/**
 * @public
 */
export interface IToastRef<TData = any, TResult = any> extends IResolveRejectRef<ToastComponent, TData, TResult> {}
